<template>
	<div class="assessment-progress-bar">
		<div class="progress-bar-text-sec">
			<div class="second-text header4">{{ label }}</div>
			<div class="rate-text header4">{{ value | toThousands }}{{ metric }}</div>
		</div>
		<progress-bar :options="options" :value="parseInt(percent) || 0" />
	</div>
</template>

<script>
import ProgressBar from "vuejs-progress-bar";

export default {
	name: "assessment-progress-bar",
	props: {
		value: String,
		percent: Number,
		label: String,
		index: Number,
		metric: String,
	},
	data: function () {
		return {
			options: {
				text: {
					color: "#FFFFFF",
					shadowEnable: false,
					shadowColor: "#000000",
					fontSize: 14,
					fontFamily: "Helvetica",
					dynamicPosition: false,
					hideText: true,
				},
				progress: {
					color: this.color(),
					backgroundColor: "#fff",
				},
				layout: {
					height: 20,
					// width: 550,
					width: 350,
					verticalTextAlign: 61,
					horizontalTextAlign: 43,
					zeroOffset: 0,
					strokeWidth: 30,
					progressPadding: 0,
					type: "line",
				},
			},
		};
	},
	methods: {
		color() {
			let color;
			switch (this.index) {
				case 0:
					color = "#6100FF";
					break;
				case 1:
					color = "#6DD7C7";
					break;
				case 2:
					color = "#C099FF";
					break;
				default:
					color = "#6100FF";
			}
			return color;
		},
	},
};
</script>

<style scoped lang="scss">
.assessment-progress-bar {
	// width: 550px;
	.progress-bar-text-sec {
		display: flex;
		justify-content: space-between;
		// padding: 0 20px;
	}
	// #progress-bar-line {
	// 	svg#line-progress {
	// 		width: 550px;
	// 	}
	// }
	.vuejs-progress-bar {
		margin-top: 10px;
		// margin-left: 20px;
		height: 20px;
	}
	.header4 {
		color: var(--black);
	}
}
@media screen and (max-width: 414px) {
	.assessment-progress-bar {
		display: grid;
		// grid-template-columns: repeat(auto-fit, minmax(370px, 1fr));
		.progress-bar-text-sec {
			display: grid;
			// grid-template-columns: repeat(auto-fit, minmax(370px, 1fr));
			grid-template-columns: 1fr;
		}
		// #progress-bar-line {
		// 	svg#line-progress {
		// 		width: unset !important;
		// 	}
		// }
	}
}
</style>
